<template>
  <div class="min-h-screen" id="home">
    <!-- <div class="" style="position: relative;">
      <div class="banner-swiper w-full">
        <div class="swiper-wrapper">
          <template>
            <div class="swiper-slide">
              <img @click="to('AI')" src="https://1312339042.vod-qcloud.com/70030745vodsh1312339042/537c5e225145403692739094240/CYBiEWfks20A.gif"
                style="image-rendering: pixelated;cursor: pointer;width: 100%;height:110vh;" />
              <div style="position: absolute;bottom: 240px;color: #fff;left: calc((100% - 1400px) / 2)">
                <div style="font-size: 48px;">AI大模型服务平台</div>
                <div style="font-size: 48px;">适配于DeepSeek大模型</div>
                <div style="font-size: 24px;margin-top: 50px;opacity: 0.8;">驱动企业智能化深度变革，释放数据价值，重塑业务增长引擎</div>
              </div>
            </div>
            <div class="swiper-slide">
              <img @click="to('solution')" src="https://1312339042.vod-qcloud.com/110f907evodcq1312339042/6e42255f5145403692736108235/kInNyHgwFLwA.gif"
                style="image-rendering: pixelated;cursor: pointer;width: 100%;height:110vh;" />
              <div style="position: absolute;bottom: 260px;color: #fff;left: calc((100% - 1400px) / 2)">
                <div style="font-size: 48px;">全场景定制开发解决方案</div>
                <div style="font-size: 24px;margin-top: 50px;opacity: 0.8;">敏捷开发快速迭代｜私有化+云端协同部署｜跨平台API深度集成</div>
                <div style="font-size: 24px;margin-top: 10px;opacity: 0.8;">AI+大数据中台搭建｜存量系统架构升级｜7x24小时运维保障</div>
              </div>
            </div>
            <div class="swiper-slide">
              <img @click="to('aboutus')" src="https://1312339042.vod-qcloud.com/110f907evodcq1312339042/67fcac4a5145403692739925218/HNXx4S5K534A.gif"
                style="image-rendering: pixelated;cursor: pointer;width: 100%;height:110vh;" />
              <div style="position: absolute;bottom: 260px;color: #fff;left: calc((100% - 1400px) / 2)">
                <div style="font-size: 48px;">平台 + 应用 + 服务 = 用户价值</div>
                <div style="font-size: 24px;margin-top: 50px;opacity: 0.8;">我们深知，ToB价值的最大化源于扎实的平台底座、贴身的场景应用与可靠的全流程服务保障
                </div>
                <div style="font-size: 24px;margin-top: 10px;opacity: 0.8;">三者融合一体，构建持续进化的智能价值引擎</div>
              </div>
            </div>
          </template>
</div>
<div class="swiper-button-prev" style="top: auto;left: calc((100% - 1400px) / 2);bottom: 50px;z-index: 9999;">
</div>
<div class="swiper-button-next"
  style="top: auto;right: auto;left: calc((100% - 1280px) / 2);bottom: 50px;z-index: 9999;"></div>
</div>
<div style="height: 145px;position: absolute;bottom: 0px;background: rgb(0 0 0 / 50%);width: 100%;z-index: 99;">
  <div
    style="text-align: right;color: #fff;line-height: 145px;font-size: 30px;margin-right: calc((100% - 1300px) / 2);">
    {{ imgindex + 1 }}-3</div>
</div>
</div> -->
    <div @click="to('AI')" style="position: relative;cursor: pointer;width: 100%;"
      :style="{ height: ispc ? '100vh' : 'auto' }">
      <!--
        首屏 banner：七牛 CDN 的 GIF 外链。
        （曾压缩为本地动态 WebP，但服务器 IIS 对 /img 下 .webp 处理不稳定，故改回 GIF 外链）
      -->
      <img alt="企业级AI综合服务商·AI大模型服务平台" src="https://1312339042.vod-qcloud.com/70030745vodsh1312339042/537c5e225145403692739094240/CYBiEWfks20A.gif"
        style="width: 100%;" :style="{ height: ispc ? '100vh' : 'auto' }" />
      <!-- <div style="position: absolute;bottom: 100px;color: #fff;left: calc((100% - 1250px) / 2)">
        <div style="font-size: 48px;">企业AI智能体中台</div>
        <div style="font-size: 48px;">打造企业专属的大模型应用底座</div>
        <div style="font-size: 24px;margin-top: 50px;opacity: 0.8;">驱动企业智能化深度变革，释放数据价值，重塑业务增长引擎</div>
      </div> -->
      <div style="position: absolute;bottom: 0px;width: 100%;height: 236px;    background-size: 100%;"
        :style="{ backgroundImage: 'url(' + require('@/assets/home/toumingc.png') + ')' }">
        <div style="display: flex;justify-content:center;margin-top: 20px;">
          <div style="color: #fff;">
            <h1 style="font-size: 50px;font-weight: bold;margin: 0;">企业级AI综合服务商</h1>
            <div style="font-size: 20px;margin-top: 20px;">让 AI 真正跑在业务线上，从平台到落地，一站式交付</div>
          </div>
          <div style="display: flex;justify-content: space-between;margin-left: 100px;">
            <div @click.stop="$router.push('/AIAgentMain')" style="display: flex;align-items: center;" class="lifors">
              <div style=""><img alt="AI智能体：企业专属的大模型应用底座" src="../../assets/home/01@2x.png" style="height: 80px;"></div>
              <div style="margin-left: 20px;">
                <div style="font-size: 22px;color: #fff;font-weight: bold;">AI智能体</div>
                <div style="font-size: 14px;color: #6eddd4;margin-top: 15px;">企业专属的</div>
                <div style="font-size: 14px;color: #6eddd4;margin-top: 5px;">大模型应用底座</div>
              </div>
            </div>
            <div @click.stop="$router.push('/AIMenu')" style="display: flex;align-items: center;margin-left: 35px;" class="lifors">
              <div style=""><img alt="AI应用定制：按场景定制开发" src="../../assets/home/02@2x.png" style="height: 80px;"></div>
              <div style="margin-left: 20px;">
                <div style="font-size: 22px;color: #fff;font-weight: bold;">AI应用定制</div>
                <div style="font-size: 14px;color: #6eddd4;margin-top: 15px;">按场景定制开发</div>
                <div style="font-size: 14px;color: #6eddd4;margin-top: 5px;">快速落地可用 AI</div>
              </div>
            </div>
            <div @click.stop="$router.push('/fdeService')" style="display: flex;align-items: center;margin-left: 35px;" class="lifors">
              <div style=""><img alt="WorkBuddy落地服务：全周期陪跑" src="../../assets/home/03@2x.png" style="height: 80px;"></div>
              <div style="margin-left: 20px;">
                <div style="font-size: 22px;color: #fff;font-weight: bold;">WorkBuddy落地服务</div>
                <div style="font-size: 14px;color: #6eddd4;margin-top: 15px;">全周期陪跑</div>
                <div style="font-size: 14px;color: #6eddd4;margin-top: 5px;">持续产出业务价值</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="position: relative;"><img alt="" src="../../assets/home/home-bj.png" style="position: absolute;width: 100%;">
    </div>

    <div style="width: 1200px;margin: 0px auto;margin-top: 100px;position: relative;border-radius: 10px;">
      <div id="homemenu">
        <div @mouseenter="tindex = 1" @click="tindex = 1" :class="{ 'ttitle': tindex == 1 }">AI应用</div>
        <div @mouseenter="tindex = 2" @click="tindex = 2" :class="{ 'ttitle': tindex == 2 }">标准产品</div>
        <div @mouseenter="tindex = 3" @click="tindex = 3" :class="{ 'ttitle': tindex == 3 }">定制应用</div>
        <div @mouseenter="tindex = 0" @click="tindex = 0" :class="{ 'ttitle': tindex == 0 }">WorkBuddy企业版</div>
      </div>

      <div
        style="border-radius: 10px;margin-top: 30px;background: #fff;box-shadow:rgb(223 223 223 / 50%) 0px 15px 20px 0px;padding: 35px 0px;">
        <div id="homeapp">
          <div v-show="tindex == 0">
            <transition name="qweqwe">
              <div v-if="tindex == 0" style="display: flex;justify-content: space-around;flex-wrap: wrap;">
                <div style="" class="lifors pointer WorkBuddyapp" @click="toz()">
                  <div style="margin-top: 10px;"><img alt="运营/管理岗位" src="../../assets/hometo/wb1@2x.png"
                      style="margin:0px auto;height: 50px;">
                  </div>
                  <div style="font-size: 18px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    运营/管理 岗位</div>
                  <div style="padding-top: 10px;">
                    <div class="homeappbutton">数据报告、趋势分析</div>
                    <div class="homeappbutton">异常识别、进度汇总</div>
                  </div>
                </div>
                <div style="" class="lifors pointer WorkBuddyapp" @click="toz()">
                  <div style="margin-top: 10px;"><img alt="产品/项目岗位" src="../../assets/hometo/wb2@2x.png"
                      style="margin:0px auto;height: 50px;">
                  </div>
                  <div style="font-size: 18px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    产品/项目 岗位</div>
                  <div style="padding-top: 10px;">
                    <div class="homeappbutton">需求管理、竞品分析</div>
                    <div class="homeappbutton">项目排期、风险识别</div>
                  </div>
                </div>
                <div style="" class="lifors pointer WorkBuddyapp" @click="toz()">
                  <div style="margin-top: 10px;"><img alt="财务/行政岗位" src="../../assets/hometo/wb3@2x.png"
                      style="margin:0px auto;height: 50px;">
                  </div>
                  <div style="font-size: 18px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    财务/行政岗位</div>
                  <div style="padding-top: 10px;">
                    <div class="homeappbutton">报销审核、财务看板</div>
                    <div class="homeappbutton">合规检查、预算分析</div>
                  </div>
                </div>
                <!-- <div style="width: 1px;background: rgb(240, 240, 240);height: 280px;margin: 0px 18px;"></div> -->
                <div style="" class="lifors pointer WorkBuddyapp" @click="toz()">
                  <div style="margin-top: 20px;"><img alt="市场/品牌岗位" src="../../assets/hometo/wb4@2x.png"
                      style="margin:0px auto;height: 50px;">
                  </div>
                  <div style="font-size: 18px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    市场/品牌 岗位</div>
                  <div style="padding-top: 10px;">
                    <div class="homeappbutton">物料生成、文案创作</div>
                    <div class="homeappbutton">品牌调研、活动策划</div>
                  </div>
                </div>
                <div style="" class="lifors pointer WorkBuddyapp" @click="toz()">
                  <div style="margin-top: 20px;"><img alt="供应链/采购岗位" src="../../assets/hometo/wb5@2x.png"
                      style="margin:0px auto;height: 50px;">
                  </div>
                  <div style="font-size: 18px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    供应链/采购 岗位</div>
                  <div style="padding-top: 10px;">
                    <div class="homeappbutton">数据汇总、进度分析</div>
                    <div class="homeappbutton">供应商评估、交付跟踪</div>
                  </div>
                </div>
                <div style="" class="lifors pointer WorkBuddyapp" @click="toz()">
                  <div style="margin-top: 10px;"><img alt="HR/人事岗位" src="../../assets/hometo/wb6@2x.png"
                      style="margin:0px auto;height: 50px;">
                  </div>
                  <div style="font-size: 18px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    HR/人事 岗位</div>
                  <div style="padding-top: 10px;">
                    <div class="homeappbutton">简历筛选、面试评价</div>
                    <div class="homeappbutton">考勤分析、绩效评定</div>
                  </div>
                </div>
                <div style="" class="lifors pointer WorkBuddyapp" @click="toz()">
                  <div style="margin-top: 10px;"><img alt="销售、售前岗位" src="../../assets/hometo/wb7@2x.png"
                      style="margin:0px auto;height: 50px;">
                  </div>
                  <div style="font-size: 18px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    销售、售前 岗位</div>
                  <div style="padding-top: 10px;">
                    <div class="homeappbutton">项目方案、行业分析</div>
                    <div class="homeappbutton">客户跟踪、风险预警</div>
                  </div>
                </div>
                <div style="" class="lifors pointer WorkBuddyapp" @click="toz()">
                  <div style="margin-top: 10px;"><img alt="全员通用岗位" src="../../assets/hometo/wb8@2x.png"
                      style="margin:0px auto;height: 50px;">
                  </div>
                  <div style="font-size: 18px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                    全员通用</div>
                  <div style="padding-top: 10px;">
                    <div class="homeappbutton">邮件日程、自动提醒</div>
                    <div class="homeappbutton">会议纪要、周报生成</div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div v-show="tindex == 1" style="position: relative;">
            <img alt="" src="../../assets/home/bj.jpg" style="position: absolute;bottom: -35px;opacity: 0.9;">
            <div style="position: relative;z-index: 1;padding-bottom: 70px;">
              <transition name="qweqwe">
                <div v-if="tindex == 1" style="display: flex;justify-content: center;">
                  <div style="width: 190px;">
                    <!-- <div class="lifors pointer" @click="tof('AI智能体中台')">
                      <div style="margin-top: 20px;"><img alt="AI智能体中台" src="../../assets/home/ai11@2x@2x.png"
                          style="margin:0px auto;height: 50px;">
                      </div>
                      <div style="font-size: 16px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        AI智能体中台</div>
                      <div style="font-size: 14px;margin-top: 15px;line-height: 25px;color: #666666;">
                        构建企业级智能体平台，实现AI驱动的组织变革
                      </div>
                    </div> -->

                    <div class="lifors pointer" @click="tof('AI会议纪要生成器')">
                      <div style="margin-top: 20px;"><img alt="AI会议纪要生成器" src="../../assets/home/ai11@2x@2xb.png"
                          style="margin:0px auto;height: 50px;">
                      </div>
                      <div style="font-size: 16px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        AI会议纪要生成器</div>
                      <div style="font-size: 14px;margin-top: 15px;line-height: 25px;color: #666666;">
                        自动整理会议内容，提取决议与待办事项
                      </div>
                    </div>
                    <div style="margin-top: 50px;" class="lifors pointer" @click="tof('智能安防AI预警')">
                      <div style="margin-top: 20px;"><img alt="智能安防AI预警" src="../../assets/home/ai4@2x.png"
                          style="margin:0px auto;height: 50px;">
                      </div>
                      <div style="font-size: 16px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        智能安防AI预警</div>
                      <div style="font-size: 14px;margin-top: 15px;line-height: 25px;color: #666666;">
                        无人机巡检+AI图像识别，实时预警隐患
                      </div>
                    </div>
                  </div>
                  <div style="width: 1px;background: rgb(240, 240, 240);height: 370px;margin: 0px 23px;"></div>
                  <div style="width: 190px;">
                    <div class="lifors pointer" @click="tof('AI舆情监测')">
                      <div style="margin-top: 20px;"><img alt="AI舆情监测" src="../../assets/home/ai5@2x.png"
                          style="margin:0px auto;height: 50px;">
                      </div>
                      <div style="font-size: 16px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        AI舆情监测</div>
                      <div style="font-size: 14px;margin-top: 15px;line-height: 25px;color: #666666;">
                        监测企业微信，分析敏感词意图，主动预警内部风险
                      </div>
                    </div>
                    <div style="margin-top: 50px;" class="lifors pointer" @click="tof('智能运维接管')">
                      <div style="margin-top: 20px;"><img alt="智能运维接管" src="../../assets/home/ai6@2x.png"
                          style="margin:0px auto;height: 50px;">
                      </div>
                      <div style="font-size: 16px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        智能运维接管</div>
                      <div style="font-size: 14px;margin-top: 15px;line-height: 25px;color: #666666;">
                        AI分析报修描述，自动分流问题，提供自助排查建议
                      </div>
                    </div>
                  </div>
                  <div style="width: 1px;background: rgb(240, 240, 240);height: 370px;margin: 0px 23px;"></div>
                  <div style="width: 190px;">
                    <div class="lifors pointer" @click="tof('智慧财务服务助手')">
                      <div style="margin-top: 20px;"><img alt="智慧财务服务助手" src="../../assets/home/ai@2x.png"
                          style="margin:0px auto;height: 50px;">
                      </div>
                      <div style="font-size: 16px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        智慧财务服务助手</div>
                      <div style="font-size: 14px;margin-top: 15px;line-height: 25px;color: #666666;">
                        自然语言解答财务政策，支持进度查询与催办
                      </div>
                    </div>
                    <div style="margin-top: 50px;" class="lifors pointer" @click="tof('网络日志智能报表')">
                      <div style="margin-top: 20px;"><img alt="网络日志智能报表" src="../../assets/home/ai7@2x.png"
                          style="margin:0px auto;height: 50px;">
                      </div>
                      <div style="font-size: 16px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        网络日志智能报表</div>
                      <div style="font-size: 14px;margin-top: 15px;line-height: 25px;color: #666666;">
                        RPA+AI自动分析日志，生成带风险等级的安全报告
                      </div>
                    </div>
                  </div>
                  <div style="width: 1px;background: rgb(240, 240, 240);height: 370px;margin: 0px 23px;"></div>
                  <div style="width: 190px;">
                    <div class="lifors pointer" @click="tof('AI知识库')">
                      <div style="margin-top: 20px;"><img alt="AI知识库" src="../../assets/home/ai1@2x.png"
                          style="margin:0px auto;height: 50px;">
                      </div>
                      <div style="font-size: 16px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        AI知识库</div>
                      <div style="font-size: 14px;margin-top: 15px;line-height: 25px;color: #666666;">
                        整合多源数据，构建企业知识中枢
                      </div>
                    </div>
                    <div style="margin-top: 50px;" class="lifors pointer" @click="tof('招投标助手')">
                      <div style="margin-top: 20px;"><img alt="招投标助手" src="../../assets/home/ai8@2x.png"
                          style="margin:0px auto;height: 50px;">
                      </div>
                      <div style="font-size: 16px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        招投标助手</div>
                      <div style="font-size: 14px;margin-top: 15px;line-height: 25px;color: #666666;">
                        AI解析招标关键点，比对投标偏差，辅助标书编写审核
                      </div>
                    </div>
                  </div>
                  <div style="width: 1px;background: rgb(240, 240, 240);height: 370px;margin: 0px 23px;"></div>
                  <div style="width: 200px;">
                    <div class="lifors pointer" @click="tof('AI智能客服')">
                      <div style="margin-top: 20px;"><img alt="AI智能客服" src="../../assets/home/ai2@2x.png"
                          style="margin:0px auto;height: 50px;">
                      </div>
                      <div style="font-size: 16px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        AI智能客服</div>
                      <div style="font-size: 14px;margin-top: 15px;line-height: 25px;color: #666666;">
                        生成式AI全渠道对话引擎实现服务与业务智能化
                      </div>
                    </div>
                    <div style="margin-top: 50px;" class="lifors pointer" @click="tof('施工技术方案智能审核平台')">
                      <div style="margin-top: 20px;"><img alt="施工技术方案智能审核平台" src="../../assets/home/ai9@2x.png"
                          style="margin:0px auto;height: 50px;">
                      </div>
                      <div style="font-size: 16px;font-weight: bold;color: #333;margin-top: 15px;text-align: center;">
                        施工技术方案智能审核平台</div>
                      <div style="font-size: 14px;margin-top: 15px;line-height: 25px;color: #666666;">
                        AI学习行业规范，自动审核，一键生成评审报告
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <div v-show="tindex == 2">
            <transition name="qweqwe">
              <div v-if="tindex == 2" style="display: flex;justify-content: space-around;">
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>办公协作
                  </div>
                  <!-- width: 474px; -->
                  <div style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;">
                    <div @click="tod('企业微信')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="企业微信" src="../../assets/home/xt1@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">企业微信</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">连接微信生态的企业协同中...</div>
                      </div>
                    </div>
                    <!-- <div @click="tod('效率套件')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="效率套件" src="../../assets/home/xt2@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">效率套件</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">融合邮箱、微盘、文档的...</div>
                      </div>
                    </div> -->
                    <div @click="tod('企业邮箱')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="企业邮箱" src="../../assets/home/635@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">企业邮箱</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">微信收发邮件的企业邮箱</div>
                      </div>
                    </div>
                    <div @click="tod('腾讯会议')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="腾讯会议" src="../../assets/home/xt3@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯会议</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">亿级用户信赖的智能云会议...</div>
                      </div>
                    </div>
                    <!-- <div @click="tod('腾讯文档')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="腾讯文档" src="../../assets/home/xt8@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯文档</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">智能云端协作文档平台</div>
                      </div>
                    </div> -->
                    <div @click="tod('腾讯乐享')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="腾讯乐享" src="../../assets/home/xt4@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯乐享</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">一站式企业知识社区平台</div>
                      </div>
                    </div>
                    <!-- <div @click="tod('腾讯问卷')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="腾讯问卷" src="../../assets/home/xt5@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯问卷</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">专业调研数据收集工具</div>
                      </div>
                    </div> -->
                    <!-- <div @click="tod('腾讯电子签')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="腾讯电子签" src="../../assets/home/xt7@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯电子签</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">10秒签约，具备法律效力</div>
                      </div>
                    </div> -->
                    <!-- <div @click="tod('TAPD敏捷项目管理')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="TAPD敏捷项目管理" src="../../assets/home/xt6@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">TAPD敏捷项目管理</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">一站式敏捷研发协作平台</div>
                      </div>
                    </div> -->
                  </div>
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 335px;margin: 0px 5px;"></div>
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>客户服务与营销
                  </div>
                  <div style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;">
                    <div @click="tod('企业微信会话存档')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="企业微信会话存档" src="../../assets/home/aq1@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">企业微信会话存档</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">合规存档企业沟通记录</div>
                      </div>
                    </div>
                    <!-- <div @click="tod('腾讯微卡')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="腾讯微卡" src="../../assets/home/kh2@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯微卡</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">全场景身份支付管理平台</div>
                      </div>
                    </div> -->
                    <div @click="tod('客服大模型机器人')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="客服大模型机器人" src="../../assets/home/kh3@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">客服大模型机器人</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">AI驱动智能客服机器人</div>
                      </div>
                    </div>
                    <div @click="tod('企点营销云')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="企点营销云" src="../../assets/home/kh4@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">企点营销云</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">企点营销云</div>
                      </div>
                    </div>
                    <div @click="tod('腾讯企点')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="腾讯企点" src="../../assets/home/kh1@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯企点</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">全渠道智能客服营销平台</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div style="width: 1px;background: rgb(240, 240, 240);height: 335px;margin: 0px 5px;"></div>
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>AI智能体平台
                  </div>
                  <div style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;">
                    <div @click="tod('WorkBuddy桌面虾')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="WorkBuddy桌面虾" src="../../assets/home/xt10@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">WorkBuddy桌面虾</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">AI原生桌面智能体工作台</div>
                      </div>
                    </div>
                    <div @click="tod('CodeBuddy编程虾')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="CodeBuddy编程虾" src="../../assets/home/xt11@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">CodeBuddy编程虾</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">AI编程助手</div>
                      </div>
                    </div>
                    <div @click="tod('大模型服务平台TokenHub')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="大模型服务平台TokenHub" src="../../assets/home/xt12@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">大模型服务平台TokenHub</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">一站式大模型Token管理</div>
                      </div>
                    </div>
                    <div @click="tod('腾讯云智能体开发平台')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="腾讯云智能体开发平台" src="../../assets/home/xt13@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯云智能体开发平台</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">一站式AI智能体构建平台</div>
                      </div>
                    </div>
                  </div>
                </div> -->
                <div style="width: 1px;background: rgb(240, 240, 240);height: 335px;margin: 0px 5px;"></div>
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>安全保障
                  </div>
                  <div style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;">
                    <div @click="tod('企业微信安全高级功能')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="企业微信安全高级功能" src="../../assets/home/637@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">企业微信安全高级功能</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">企业信息防泄漏统一管控</div>
                      </div>
                    </div>
                    <div @click="tod('企业微信数据保障')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="企业微信数据保障" src="../../assets/home/aq3@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">企业微信数据保障</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">企业数据备份恢复方案</div>
                      </div>
                    </div>
                    <div @click="tod('企业微信安全网关')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="企业微信安全网关" src="../../assets/home/636@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">企业微信安全网关</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">跨网安全访问内网应用</div>
                      </div>
                    </div>
                    <div @click="tod('腾讯iOA零信任')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="腾讯iOA零信任" src="../../assets/home/aq2@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯iOA零信任</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">动态鉴权，保障全域安全</div>
                      </div>
                    </div>
                    <!-- <div @click="tod('企业网盘')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="企业网盘" src="../../assets/home/aq4@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">企业网盘</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">安全高效企业文件管理</div>
                      </div>
                    </div> -->
                  </div>
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 335px;margin: 0px 5px;"></div>
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>国产化与信创方案
                  </div>
                  <div style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;">
                    <div @click="tod('企微私有化（信创版）')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="企微私有化（信创版）" src="../../assets/home/gch1@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">企微私有化（信创版）</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">企业微信私有部署方案</div>
                      </div>
                    </div>
                    <div @click="tod('腾讯会议混合云')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="腾讯会议混合云" src="../../assets/home/gch2@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">腾讯会议混合云</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">混合部署会议解决方案</div>
                      </div>
                    </div>
                    <div @click="tod('TencentOS Server')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="TencentOS Server" src="../../assets/home/gch3@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">TencentOS Server</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">腾讯自研AI增强型操作系统</div>
                      </div>
                    </div>
                    <div @click="tod('分布式数据库TDSQL')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="分布式数据库TDSQL" src="../../assets/home/gch4@2x.png" style="height: 50px;width: 50px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">分布式数据库TDSQL</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">高性能分布式数据库</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div v-show="tindex == 3">
            <transition name="qweqwe">
              <div v-if="tindex == 3" style="display: flex;justify-content: center;">
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>精品应用
                  </div>
                  <div style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;">
                    <div @click="toc('SCRM私域运营系统')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="SCRM私域运营系统" src="../../assets/home/jp1@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">SCRM私域运营系统</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">微信生态全链路私域增长平台</div>
                      </div>
                    </div>
                    <div @click="toc('微信一体化服务平台')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="微信一体化服务平台" src="../../assets/home/jp2@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">微信一体化服务平台</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">企业微信+公众号统一管理中枢</div>
                      </div>
                    </div>
                    <div @click="toc('会话存档助手')" class="happ"
                      style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="会话存档助手" src="../../assets/home/jp3@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">会话存档助手</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">会话智能存管与风控平台</div>
                      </div>
                    </div>
                    <div @click="toc('会议助手')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="会议助手" src="../../assets/home/jp4@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">会议助手</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">全流程智能会议协同助手</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 335px;margin: 0px 15px;"></div>
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>移动办公
                  </div>
                  <div
                    style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;width: 420px;">
                    <div @click="toc('员工考勤')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="员工考勤" src="../../assets/home/yd1@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">员工考勤</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">智能移动考勤闭环管理</div>
                      </div>
                    </div>
                    <div @click="toc('流程审批')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="流程审批" src="../../assets/home/yd2@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">流程审批</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">全流程电子审批规则引擎</div>
                      </div>
                    </div>
                    <div @click="toc('公文管理')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="公文管理" src="../../assets/home/yd3@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">公文管理</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">公文全流程规范管控</div>
                      </div>
                    </div>
                    <div @click="toc('任务管理')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="任务管理" src="../../assets/home/yd4@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">任务管理</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">任务协同追踪可视化管理</div>
                      </div>
                    </div>
                    <div @click="toc('用车管理')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="用车管理" src="../../assets/home/yd5@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">用车管理</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">公车智能管控全周期方案</div>
                      </div>
                    </div>
                    <div @click="toc('资产管理')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="资产管理" src="../../assets/home/yd6@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">资产管理</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">资产全生命周期精益管理</div>
                      </div>
                    </div>
                    <div @click="toc('日程安排')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="日程安排" src="../../assets/home/yd7@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">日程安排</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">多端智能日程协同规划</div>
                      </div>
                    </div>
                    <div @click="toc('工地巡检')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="工地巡检" src="../../assets/home/yd8@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">工地巡检</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">移动巡检隐患闭环管理</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 335px;margin: 0px 15px;"></div>
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>企业服务
                  </div>
                  <div style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;">
                    <div @click="toc('访客预约')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="访客预约" src="../../assets/home/qy1@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">访客预约</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">访客全流程智能通行管控</div>
                      </div>
                    </div>
                    <div @click="toc('培训考试')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="培训考试" src="../../assets/home/qy2@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">培训考试</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">轻量化在线学习考核平台</div>
                      </div>
                    </div>
                    <div @click="toc('食堂报餐')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="食堂报餐" src="../../assets/home/qy3@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">食堂报餐</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">智慧食堂报餐管理工具</div>
                      </div>
                    </div>
                    <div @click="toc('岗位竞聘')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="岗位竞聘" src="../../assets/home/qy4@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">岗位竞聘</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">内部竞聘数字化流转平台</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 1px;background: rgb(240, 240, 240);height: 335px;margin: 0px 15px;"></div>
                <div>
                  <div style="margin-left: 10px;" class="cprimary fbold file falign">
                    <div style="width: 3px;height: 14px;margin-right:10px ;" class="bprimary"></div>智慧校园
                  </div>
                  <div style="margin-top: 15px;display: flex;flex-direction: column;flex-wrap: wrap;height: 330px;">
                    <div @click="toc('教室预定')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="教室预定" src="../../assets/home/xy1@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">教室预定</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">高校自习室数字化预订系统</div>
                      </div>
                    </div>
                    <div @click="toc('活动报名')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="活动报名" src="../../assets/home/xy2@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">活动报名</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">校园活动全链路参与平台</div>
                      </div>
                    </div>
                    <div @click="toc('校友捐赠')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="校友捐赠" src="../../assets/home/xy3@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">校友捐赠</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">校友捐赠透明化管理平台</div>
                      </div>
                    </div>
                    <div @click="toc('故障报修')" class="happ" style="padding:12px 10px;display: flex;align-items: center;">
                      <div><img alt="故障报修" src="../../assets/home/xy4@2x.png" style="height: 40px;width: 40px;"></div>
                      <div style="margin-left: 12px;">
                        <div style="font-size: 14px;">故障报修</div>
                        <div style="font-size: 12px;color: #999999;margin-top: 6px;">响应式在线报修闭环系统</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div v-if="tindex > 1" @click="toe" class="buttondh"
          style="margin: 0px auto;width: 120px;height: 36px;line-height: 36px;text-align: center;border: 1px solid #1e66d1;border-radius: 10px;font-size: 14px;color: #1e66d1;cursor: pointer;">
          查看更多 >
        </div>
      </div>
    </div>

    <div style="margin: 0px auto;margin-top: 130px;">
      <div id="homemenu">
        <div @mouseenter="windex = 0" @click="windex = 0" :class="{ 'ttitle': windex == 0 }">行业AI定制解决方案</div>
        <div @mouseenter="windex = 1" @click="windex = 1" :class="{ 'ttitle': windex == 1 }">WorkBuddy行业应用案例</div>
      </div>
      <div v-if="windex == 1"
        style="margin-top:80px;padding: 0px 38px;width: 100%;overflow-x: auto;cursor: pointer;height: 488px;"
        class="scroll-container" id="scrollcontainer">
        <div
          style="width:3680px;display: flex;justify-content: space-between;position: relative;user-select: none;margin-top: 5px;">
          <div class="workbudoyhangye" @click="tog(0)">
            <div :style="{ backgroundImage: 'url(' + require('@/assets/hometo/01@2x.png') + ')' }"
              style="height: 55px;background-size:100% 100%;text-align: center;line-height: 55px;font-size: 23px;color: #fff;">
              制造业
            </div>
            <div style="background: #f9fafb;padding:30px 0px;border-radius: 10px;">
              <div style="width: 100px;margin: 0px auto;"><img alt="制造业AI定制解决方案" src="../../assets/hometo/tb-01@2x.png"></div>
              <div style="margin-top: 35px;font-size: 15px;padding-left: 50px;">
                <div>★ 合同/报价单自动生成与智能审核</div>
                <div style="margin-top: 10px;">★ 生产报表自动汇总·ERP/SRM/钉钉打通</div>
                <div style="margin-top: 10px;">★ 多基地运营数据分析与一句话生成日报</div>
                <div style="margin-top: 10px;">★ 技术文档智能检素与流程标准化</div>
              </div>
              <div
                style="background: #fff;color: #1e66d1;text-align: center;font-weight: bold;
              height: 40px;line-height: 40px;margin-top: 30px;margin-bottom: 20px;box-shadow:rgb(205 205 205 / 50%) 0px 4px 10px 0px;">
                事务性时间省70%·文档查找-70%
              </div>
            </div>
          </div>
          <div class="workbudoyhangye" @click="tog(1)">
            <div :style="{ backgroundImage: 'url(' + require('@/assets/hometo/02@2x.png') + ')' }"
              style="height: 55px;background-size:100% 100%;text-align: center;line-height: 55px;font-size: 23px;color: #fff;">
              电商/跨境电商
            </div>
            <div style="background: #f9fafb;padding:30px 0px;border-radius: 10px;">
              <div style="width: 100px;margin: 0px auto;"><img alt="电商跨境电商AI定制解决方案" src="../../assets/hometo/tb-02@2x.png"></div>
              <div style="margin-top: 35px;font-size: 15px;padding-left: 50px;">
                <div>★ 多语种客服与产品详情文案</div>
                <div style="margin-top: 10px;">★ 跨境电商大盘监控，广告投流优化</div>
                <div style="margin-top: 10px;">★ ERP订单，营销文案，图片批量处理</div>
                <div style="margin-top: 10px;">★ 智能客服，Al运营预测，内容自动化</div>
              </div>
              <div
                style="background: #fff;color: rgb(234 88 12);text-align: center;font-weight: bold;
              height: 40px;line-height: 40px;margin-top: 30px;margin-bottom: 20px;box-shadow:rgb(205 205 205 / 50%) 0px 4px 10px 0px;">
                数据处理-80%·运营效率+30%
              </div>
            </div>
          </div>
          <div class="workbudoyhangye" @click="tog(2)">
            <div :style="{ backgroundImage: 'url(' + require('@/assets/hometo/03@2x.png') + ')' }"
              style="height: 55px;background-size:100% 100%;text-align: center;line-height: 55px;font-size: 23px;color: #fff;">
              医疗医药/生物科技
            </div>
            <div style="background: #f9fafb;padding:30px 0px;border-radius: 10px;">
              <div style="width: 100px;margin: 0px auto;"><img alt="医疗医药生物科技AI定制解决方案" src="../../assets/hometo/tb-03@2x.png"></div>
              <div style="margin-top: 35px;font-size: 15px;padding-left: 50px;">
                <div>★ GMP合规文档生成与法务合同初审</div>
                <div style="margin-top: 10px;">★ 批生产记录与检验报告自动填充</div>
                <div style="margin-top: 10px;">★ 实验报告AI生成·文献语义检索</div>
                <div style="margin-top: 10px;">★ 专项助手，自定义Skills·用量管理</div>
              </div>
              <div
                style="background: #fff;color: rgb(22 163 74);text-align: center;font-weight: bold;
              height: 40px;line-height: 40px;margin-top: 30px;margin-bottom: 20px;box-shadow:rgb(205 205 205 / 50%) 0px 4px 10px 0px;">
                人力时间-90%·新人上手-50%
              </div>
            </div>
          </div>
          <div class="workbudoyhangye" @click="tog(3)">
            <div :style="{ backgroundImage: 'url(' + require('@/assets/hometo/04@2x.png') + ')' }"
              style="height: 55px;background-size:100% 100%;text-align: center;line-height: 55px;font-size: 23px;color: #fff;">
              金融行业
            </div>
            <div style="background: #f9fafb;padding:30px 0px;border-radius: 10px;">
              <div style="width: 100px;margin: 0px auto;"><img alt="金融行业AI定制解决方案" src="../../assets/hometo/tb-04@2x.png"></div>
              <div style="margin-top: 35px;font-size: 15px;padding-left: 50px;">
                <div>★ 资讯抓取与研报自动撰写</div>
                <div style="margin-top: 10px;">★ 报表自动生成·风控指标看板</div>
                <div style="margin-top: 10px;">★ 金融走势分析与选股Skills</div>
                <div style="margin-top: 10px;">★ 资产投资决策提效·风险处置</div>
              </div>
              <div
                style="background: #fff;color: rgb(122 75 202);text-align: center;font-weight: bold;
              height: 40px;line-height: 40px;margin-top: 30px;margin-bottom: 20px;box-shadow:rgb(205 205 205 / 50%) 0px 4px 10px 0px;">
                报表等待-70%·合规南查-50%
              </div>
            </div>
          </div>
          <div class="workbudoyhangye" @click="tog(4)">
            <div :style="{ backgroundImage: 'url(' + require('@/assets/hometo/05@2x.png') + ')' }"
              style="height: 55px;background-size:100% 100%;text-align: center;line-height: 55px;font-size: 23px;color: #fff;">
              建筑装饰/科技服务
            </div>
            <div style="background: #f9fafb;padding:30px 0px;border-radius: 10px;">
              <div style="width: 100px;margin: 0px auto;"><img alt="建筑装饰科技服务AI定制解决方案" src="../../assets/hometo/tb-05@2x.png"></div>
              <div style="margin-top: 35px;font-size: 15px;padding-left: 50px;">
                <div>★ 标书与报价单自动生成</div>
                <div style="margin-top: 10px;">★ 项目方案书掇写与数据扒取</div>
                <div style="margin-top: 10px;">★ 营销文案合规审核·条款校验</div>
                <div style="margin-top: 10px;">★ 合同自动生成，客服标准回复</div>
              </div>
              <div
                style="background: #fff;color: rgb(138 69 28);text-align: center;font-weight: bold;
              height: 40px;line-height: 40px;margin-top: 30px;margin-bottom: 20px;box-shadow:rgb(205 205 205 / 50%) 0px 4px 10px 0px;">
                合同30min→3min·投标响应+70%
              </div>
            </div>
          </div>
          <div class="workbudoyhangye" @click="tog(5)">
            <div :style="{ backgroundImage: 'url(' + require('@/assets/hometo/06@2x.png') + ')' }"
              style="height: 55px;background-size:100% 100%;text-align: center;line-height: 55px;font-size: 23px;color: #fff;">
              媒体/广告/营销
            </div>
            <div style="background: #f9fafb;padding:30px 0px;border-radius: 10px;">
              <div style="width: 100px;margin: 0px auto;"><img alt="媒体广告营销AI定制解决方案" src="../../assets/hometo/tb-06@2x.png"></div>
              <div style="margin-top: 35px;font-size: 15px;padding-left: 50px;">
                <div>★ AI漫剧·智能内容生成</div>
                <div style="margin-top: 10px;">★ 小红书运营，营销文案批量产出</div>
                <div style="margin-top: 10px;">★ 直播脚本与招商文案生成</div>
                <div style="margin-top: 10px;">★ 创意内容流水线·活动策划提效</div>
              </div>
              <div
                style="background: #fff;color: rgb(198 61 122);text-align: center;font-weight: bold;
              height: 40px;line-height: 40px;margin-top: 30px;margin-bottom: 20px;box-shadow:rgb(205 205 205 / 50%) 0px 4px 10px 0px;">
                内容产能10x·创作耗时-80%
              </div>
            </div>
          </div>
          <div class="workbudoyhangye" @click="tog(6)">
            <div :style="{ backgroundImage: 'url(' + require('@/assets/hometo/07@2x.png') + ')' }"
              style="height: 55px;background-size:100% 100%;text-align: center;line-height: 55px;font-size: 23px;color: #fff;">
              物流/供应链
            </div>
            <div style="background: #f9fafb;padding:30px 0px;border-radius: 10px;">
              <div style="width: 100px;margin: 0px auto;"><img alt="物流供应链AI定制解决方案" src="../../assets/hometo/tb-07@2x.png"></div>
              <div style="margin-top: 35px;font-size: 15px;padding-left: 50px;height: 120px;">
                <div>★ 企微客服·RAG知识库·多模态处理</div>
                <div style="margin-top: 10px;">★ 报关单OCR识别·票务自动化</div>
                <div style="margin-top: 10px;">★ 运维开发提效·ERP内部系统</div>
              </div>
              <div
                style="background: #fff;color: rgb(14 139 169);text-align: center;font-weight: bold;
              height: 40px;line-height: 40px;margin-top: 30px;margin-bottom: 20px;box-shadow:rgb(205 205 205 / 50%) 0px 4px 10px 0px;">
                人工录入-90%·处理量+10x
              </div>
            </div>
          </div>
          <div class="workbudoyhangye" @click="tog(7)">
            <div :style="{ backgroundImage: 'url(' + require('@/assets/hometo/08@2x.png') + ')' }"
              style="height: 55px;background-size:100% 100%;text-align: center;line-height: 55px;font-size: 23px;color: #fff;">
              汽车
            </div>
            <div style="background: #f9fafb;padding:30px 0px;border-radius: 10px;">
              <div style="width: 100px;margin: 0px auto;"><img alt="汽车行业AI定制解决方案" src="../../assets/hometo/tb-08@2x.png"></div>
              <div style="margin-top: 35px;font-size: 15px;padding-left: 50px;height: 120px;">
                <div>★ 智能编程，代码安全，合规交付</div>
                <div style="margin-top: 10px;">★ 报表录入·Figma设计解析·库存盘点</div>
                <div style="margin-top: 10px;">★ 车载系统深度开发，漏洞排查</div>
              </div>
              <div
                style="background: #fff;color: rgb(193 49 49);text-align: center;font-weight: bold;
              height: 40px;line-height: 40px;margin-top: 30px;margin-bottom: 20px;box-shadow:rgb(205 205 205 / 50%) 0px 4px 10px 0px;">
                研发效率+40%·缺陷-50%
              </div>
            </div>
          </div>
          <div class="workbudoyhangye" @click="tog(8)">
            <div :style="{ backgroundImage: 'url(' + require('@/assets/hometo/09@2x.png') + ')' }"
              style="height: 55px;background-size:100% 100%;text-align: center;line-height: 55px;font-size: 23px;color: #fff;">
              教育/培训
            </div>
            <div style="background: #f9fafb;padding:30px 0px;border-radius: 10px;">
              <div style="width: 100px;margin: 0px auto;"><img alt="教育/培训AI定制解决方案" src="../../assets/hometo/tb-09@2x.png"></div>
              <div style="margin-top: 35px;font-size: 15px;padding-left: 50px;">
                <div>★ 政策资讯智能采集·多源政府网站监控</div>
                <div style="margin-top: 10px;">★ 自动化数据采集·研究分析，领导驾驶舱</div>
                <div style="margin-top: 10px;">★ 合同审核·招标解读，教培方案·Excel提效</div>
                <div style="margin-top: 10px;">★ PPT制作·文档处理效率大幅提升</div>
              </div>
              <div
                style="background: #fff;color: rgb(192 133 9);text-align: center;font-weight: bold;
              height: 40px;line-height: 40px;margin-top: 30px;margin-bottom: 20px;box-shadow:rgb(205 205 205 / 50%) 0px 4px 10px 0px;">
                检索时间-90%·PPT制作2H→15min
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="windex == 0"
        style="margin-top:80px;padding: 0px 50px;width: 100%;overflow-x: auto;cursor: pointer;height: 600px;"
        class="scroll-container" id="scrollcontainer">
        <div
          style="width:3300px;display: flex;justify-content: space-between;position: relative;user-select: none;margin-top: 5px;">
          <div class="workbudoyhangyeb" @click="toh(0)"
            :style="{ backgroundImage: 'url(' + require('@/assets/hometo/h1.png') + ')' }"
            style="background-size:100% 100%;position: relative;margin-top: 42px;">
            <h2
              style="margin: 0; font-weight: inherit; height: 80px;text-align: center;line-height: 80px;font-size: 35px;color: #fff;background: #1e66d1;
              width: 250px;border-radius: 50px;position: absolute;top: -40px;left: 50%;transform: translate(-50%, -0%);">
              制造行业
            </h2>
            <div style="padding-left: 50px;margin-top: 290px;color: #fff;">
              <div style="font-size: 28px;line-height: 38px;">
                <div>智能制造平台</div>
                <div>降本增效提质避险</div>
              </div>
              <div style="font-size: 16px;margin-top: 30px;">
                <div>★ 设备预测性维护，降非计划停机50%+</div>
                <div style="margin-top: 10px;">★ AI视觉质检，质检效率提升40%+</div>
                <div style="margin-top: 10px;">★ 智能排产与工艺优化，缩短交期</div>
              </div>
            </div>
          </div>
          <div class="workbudoyhangyeb" @click="toh(1)"
            :style="{ backgroundImage: 'url(' + require('@/assets/hometo/h3.png') + ')' }"
            style="background-size:100% 100%;position: relative;margin-top: 42px;">
            <h2
              style="margin: 0; font-weight: inherit; height: 80px;text-align: center;line-height: 80px;font-size: 35px;color: #fff;background: #1e66d1;
              width: 250px;border-radius: 50px;position: absolute;top: -40px;left: 50%;transform: translate(-50%, -0%);">
              设计院
            </h2>
            <div style="padding-left: 50px;margin-top: 290px;color: #fff;">
              <div style="font-size: 28px;line-height: 38px;">
                <div>AI协同设计平台</div>
                <div>审图提效规范交付</div>
              </div>
              <div style="font-size: 16px;margin-top: 30px;">
                <div>★ AI智能审图，效率提升70%+</div>
                <div style="margin-top: 10px;">★ 设计知识库AI问答，经验即时复用</div>
                <div style="margin-top: 10px;">★ 跨专业协同闭环，变更影响量化</div>
              </div>
            </div>
          </div>
          <div class="workbudoyhangyeb" @click="toh(2)"
            :style="{ backgroundImage: 'url(' + require('@/assets/hometo/h4.png') + ')' }"
            style="background-size:100% 100%;position: relative;margin-top: 42px;">
            <h2
              style="margin: 0; font-weight: inherit; height: 80px;text-align: center;line-height: 80px;font-size: 35px;color: #fff;background: #1e66d1;
              width: 250px;border-radius: 50px;position: absolute;top: -40px;left: 50%;transform: translate(-50%, -0%);">
              零售行业
            </h2>
            <div style="padding-left: 50px;margin-top: 290px;color: #fff;">
              <div style="font-size: 28px;line-height: 38px;">
                <div>智慧零售全链路运营</div>
                <div>提升坪效复购</div>
              </div>
              <div style="font-size: 16px;margin-top: 30px;">
                <div>★ AI客流分析，量化门店坪效</div>
                <div style="margin-top: 10px;">★ 精准会员营销，私域流量转化</div>
                <div style="margin-top: 10px;">★ 智能选品补货，库存周转提升30%+</div>
              </div>
            </div>
          </div>
          <div class="workbudoyhangyeb" @click="toh(3)"
            :style="{ backgroundImage: 'url(' + require('@/assets/hometo/h5.png') + ')' }"
            style="background-size:100% 100%;position: relative;margin-top: 42px;">
            <h2
              style="margin: 0; font-weight: inherit; height: 80px;text-align: center;line-height: 80px;font-size: 35px;color: #fff;background: #1e66d1;
              width: 250px;border-radius: 50px;position: absolute;top: -40px;left: 50%;transform: translate(-50%, -0%);">
              金融行业
            </h2>
            <div style="padding-left: 50px;margin-top: 290px;color: #fff;">
              <div style="font-size: 28px;line-height: 38px;">
                <div>金融科技AI平台</div>
                <div>提质增效合规避险</div>
              </div>
              <div style="font-size: 16px;margin-top: 30px;">
                <div>★ 智能风控反欺诈，准确率提升50%+</div>
                <div style="margin-top: 10px;">★ 7×24智能客服，响应效率提升60%+</div>
                <div style="margin-top: 10px;">★ 合规审计自动化，效率提升40%+</div>
              </div>
            </div>
          </div>
          <div class="workbudoyhangyeb" @click="toh(4)"
            :style="{ backgroundImage: 'url(' + require('@/assets/hometo/h6.png') + ')' }"
            style="background-size:100% 100%;position: relative;margin-top: 42px;">
            <h2
              style="margin: 0; font-weight: inherit; height: 80px;text-align: center;line-height: 80px;font-size: 35px;color: #fff;background: #1e66d1;
              width: 250px;border-radius: 50px;position: absolute;top: -40px;left: 50%;transform: translate(-50%, -0%);">
              医药行业
            </h2>
            <div style="padding-left: 50px;margin-top: 290px;color: #fff;">
              <div style="font-size: 28px;line-height: 38px;">
                <div>医药数字化AI平台</div>
                <div>研发提效合规运营</div>
              </div>
              <div style="font-size: 16px;margin-top: 30px;">
                <div>★ AI辅助药物研发，效率提升35%+</div>
                <div style="margin-top: 10px;">★ 学术内容合规生成，违规即时标注</div>
                <div style="margin-top: 10px;">★ 代表效能管理，拜访计划智能排程</div>
              </div>
            </div>
          </div>
          <div class="workbudoyhangyeb" @click="toh(5)"
            :style="{ backgroundImage: 'url(' + require('@/assets/hometo/h7.png') + ')' }"
            style="background-size:100% 100%;position: relative;margin-top: 42px;">
            <h2
              style="margin: 0; font-weight: inherit; height: 80px;text-align: center;line-height: 80px;font-size: 35px;color: #fff;background: #1e66d1;
              width: 250px;border-radius: 50px;position: absolute;top: -40px;left: 50%;transform: translate(-50%, -0%);">
              集团企业
            </h2>
            <div style="padding-left: 50px;margin-top: 290px;color: #fff;">
              <div style="font-size: 28px;line-height: 38px;">
                <div>集团统一协同管控平台</div>
                <div>打破数据孤岛</div>
              </div>
              <div style="font-size: 16px;margin-top: 30px;">
                <div>★ 统一协同门户，一端聚合高频业务</div>
                <div style="margin-top: 10px;">★ 集团数据驾驶舱，异常指标自动预警</div>
                <div style="margin-top: 10px;">★ 智能审批与风控，合规覆盖全集团</div>
              </div>
            </div>
          </div>
          <div class="workbudoyhangyeb" @click="toh(6)"
            :style="{ backgroundImage: 'url(' + require('@/assets/hometo/h8.png') + ')' }"
            style="background-size:100% 100%;position: relative;margin-top: 42px;">
            <h2
              style="margin: 0; font-weight: inherit; height: 80px;text-align: center;line-height: 80px;font-size: 35px;color: #fff;background: #1e66d1;
              width: 250px;border-radius: 50px;position: absolute;top: -40px;left: 50%;transform: translate(-50%, -0%);">
              政务行业
            </h2>
            <div style="padding-left: 50px;margin-top: 290px;color: #fff;">
              <div style="font-size: 28px;line-height: 38px;">
                <div>数字政务AI平台</div>
                <div>服务提质基层减负</div>
              </div>
              <div style="font-size: 16px;margin-top: 30px;">
                <div>★ 7×24智能政务问答，咨询效率提升60%+</div>
                <div style="margin-top: 10px;">★ 一网通办智能导办，平均8分钟办结</div>
                <div style="margin-top: 10px;">★ 基层减负工作台，事务效率提升40%+</div>
              </div>
            </div>
          </div>
          <div class="workbudoyhangyeb" @click="toh(1)"
            :style="{ backgroundImage: 'url(' + require('@/assets/hometo/h2.png') + ')' }"
            style="background-size:100% 100%;position: relative;margin-top: 42px;">
            <h2
              style="margin: 0; font-weight: inherit; height: 80px;text-align: center;line-height: 80px;font-size: 35px;color: #fff;background: #1e66d1;
              width: 250px;border-radius: 50px;position: absolute;top: -40px;left: 50%;transform: translate(-50%, -0%);">
              教育行业
            </h2>
            <div style="padding-left: 50px;margin-top: 290px;color: #fff;">
              <div style="font-size: 28px;line-height: 38px;">
                <div>一体化平台</div>
                <div>赋能教学管理与服务</div>
              </div>
              <div style="font-size: 16px;margin-top: 30px;">
                <div>★ AI智能批改，教师减负60%+</div>
                <div style="margin-top: 10px;">★ 个性化学习路径，因材施教</div>
                <div style="margin-top: 10px;">★ 家校协同闭环，沟通全程可追溯</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="margin-top: 135px;position: relative;">
      <div style="position: relative;z-index: 9;">
        <div style="font-size: 40px;text-align: center;">视频介绍</div>
        <div
          style="margin: 0px auto;margin-top: 40px;width: 1200px;overflow-x: hidden;position: relative;height: 650px;">
          <div style="width: 6000px;display: flex;position: absolute;top: 0px;"
            :style="'transition:all 1s;left: ' + left + 'px;'">
            <div style="width: 1200px;display: flex;flex-wrap: wrap;" v-for="w in mp4">
              <div v-for="x in w" @click="videoShowFun(x)"
                style="cursor: pointer;width: 380px;margin:0px 10px;margin-bottom: 30px;" class="lifors">
                <div><img :src="x.img" :alt="x.title" style="border-radius: 10px;"></div>
                <div style="margin-top: 15px;">{{ x.title }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="videobutton">
          <div @click="left = 0; videobindex = 1;"
            :style="{ background: videobindex == 1 ? '#1e66d1 !important' : '#d5d5d5' }">
          </div>
          <div @click="left = -1200; videobindex = 2;"
            :style="{ background: videobindex == 2 ? '#1e66d1 !important' : '#d5d5d5' }">
          </div>
          <div @click="left = -2400; videobindex = 3;"
            :style="{ background: videobindex == 3 ? '#1e66d1 !important' : '#d5d5d5' }">
          </div>
          <div @click="left = -3600; videobindex = 4;"
            :style="{ background: videobindex == 4 ? '#1e66d1 !important' : '#d5d5d5' }">
          </div>
          <div @click="left = -4800; videobindex = 5;"
            :style="{ background: videobindex == 5 ? '#1e66d1 !important' : '#d5d5d5' }">
          </div>
        </div>
        <!-- <div class="buttondh"
          style="margin: 0px auto;width: 120px;height: 36px;line-height: 36px;text-align: center;border: 1px solid #1e66d1;border-radius: 10px;font-size: 14px;color: #1e66d1;cursor: pointer;">
          查看更多 >
        </div> -->
      </div>
      <img alt="" src="../../assets/images/index4.png" style="position: absolute;top: -120px;opacity: 0.3;">
      <!-- <img src="../../assets/images/index4.png" style="position: absolute;bottom: -350px;opacity: 0.3;"> -->
    </div>
    <!-- <div style="margin-top: 100px;position: relative;">
      <div style="font-size: 40px;text-align: center;">为各行业提供全栈解决方案</div>
      <div style="margin: 0px auto;margin-top: 60px;width: 1200px;display: flex;justify-content: space-between;"
        id="homejjfz">
        <div
          style="width: 240px;height: 440px;font-size: 14px;background: #1e66d1;color: #fff;padding:28px 15px;border-radius: 15px;">
          <div @mouseenter="hjindex = 1" @click="hjindex = 1" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 1 }">
            <div><img alt="教育行业" src="../../assets/home/hylei-1.png" style="width: 30px;height: 30px;"></div>
            <div>教育行业</div>
            <div style="width: 10px;"><label v-show="hjindex == 1">></label></div>
          </div>
          <div @mouseenter="hjindex = 2" @click="hjindex = 2" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 2 }">
            <div><img alt="制造行业" src="../../assets/home/hylei-2.png" style="width: 30px;height: 30px;"></div>
            <div>制造行业</div>
            <div style="width: 10px;"><label v-show="hjindex == 2">></label></div>
          </div>
          <div @mouseenter="hjindex = 3" @click="hjindex = 3" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 3 }">
            <div><img alt="设计院" src="../../assets/home/hylei-3.png" style="width: 30px;height: 30px;"></div>
            <div>设计院</div>
            <div style="width: 10px;"><label v-show="hjindex == 3">></label></div>
          </div>
          <div @mouseenter="hjindex = 4" @click="hjindex = 4" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 4 }">
            <div><img alt="零售行业" src="../../assets/home/hylei-4.png" style="width: 30px;height: 30px;"></div>
            <div>零售行业</div>
            <div style="width: 10px;"><label v-show="hjindex == 4">></label></div>
          </div>
          <div @mouseenter="hjindex = 5" @click="hjindex = 5" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 5 }">
            <div><img alt="金融行业" src="../../assets/home/hylei-5.png" style="width: 30px;height: 30px;"></div>
            <div>金融行业</div>
            <div style="width: 10px;"><label v-show="hjindex == 5">></label></div>
          </div>
          <div @mouseenter="hjindex = 6" @click="hjindex = 6" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 6 }">
            <div><img alt="医药行业" src="../../assets/home/hylei-6.png" style="width: 30px;height: 30px;"></div>
            <div>医药行业</div>
            <div style="width: 10px;"><label v-show="hjindex == 6">></label></div>
          </div>
          <div @mouseenter="hjindex = 7" @click="hjindex = 7" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 7 }">
            <div><img alt="集团企业" src="../../assets/home/hylei-7.png" style="width: 30px;height: 30px;"></div>
            <div>集团企业</div>
            <div style="width: 10px;"><label v-show="hjindex == 7">></label></div>
          </div>
          <div @mouseenter="hjindex = 8" @click="hjindex = 8" style="display: flex;justify-content:space-between;align-items: center;height: 48px;border-radius: 10px;
          padding:0px 5px 0px 15px;cursor: pointer;border: 0px solid transparent;" :class="{ 'hjmenu': hjindex == 8 }">
            <div><img alt="政务行业" src="../../assets/home/hylei-8.png" style="width: 30px;height: 30px;"></div>
            <div>政务行业</div>
            <div style="width: 10px;"><label v-show="hjindex == 8">></label></div>
          </div>
        </div>
        <div style="width: 945px;height: 440px;color: #fff;position: relative;">
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy1.png') + ')' }, { opacity: hjindex == 1 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 1">
                <div style="font-size: 28px;">一体化平台赋能教学管理与服务升级</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>教学数据分散难整合，决策缺乏依据</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>行政流程繁琐低效，资源调配滞后</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>师生服务体验割裂，反馈响应迟缓</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>跨场景协作壁垒高，信息互通困难</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy2.png') + ')' }, { opacity: hjindex == 2 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 2">
                <div style="font-size: 28px;">云端协同驱动敏捷制造与精准触达</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>生产数据孤立不透明，过程管控盲区多</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>设备运维依赖人工，故障响应效率低</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>跨部门协同成本高，资源调度不敏捷</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>能耗与废品率居高，绿色转型压力大</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy3.png') + ')' }, { opacity: hjindex == 3 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 3">
                <div style="font-size: 28px;">统一平台赋能设计协同与移动办公</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>项目流程割裂，跨专业协作效率低</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>知识资产分散流失，经验复用困难</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>审签依赖线下，进度延迟风险高</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>数据安全管控弱，合规隐患突出</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy4.png') + ')' }, { opacity: hjindex == 4 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 4">
                <div style="font-size: 28px;">全链路数字化融合，智能驱动人货场</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>客流转化率低，精准营销能力不足</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>线上线下库存割裂，供需匹配失衡</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>供应链响应迟缓，成本控制难度大</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>消费行为洞察弱，体验优化无依据</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy5.png') + ')' }, { opacity: hjindex == 5 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 5">
                <div style="font-size: 28px;">数字化赋能金融客户服务与智能风控</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>风控依赖人工，异常交易响应滞后</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>客户服务流程冗长，体验满意度低</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>业务数据孤岛化，营销精准度不足</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>合规审计效率低，人为操作风险高</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy6.png') + ')' }, { opacity: hjindex == 6 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 6">
                <div style="font-size: 28px;">全场景方案保障，合规生产提质效</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>质量追溯链条断裂，合规成本高昂</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>生产与研发数据脱节，良品率波动大</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>供应链温控监管难，流通安全风险高</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>文档管理效率低下，审计响应速度慢</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy7.png') + ')' }, { opacity: hjindex == 7 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 7">
                <div style="font-size: 28px;">统一管控平台驱动集团协同提效能</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>多业态数据割裂，战略协同效率低</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>审批流程层级冗长，决策周期缓慢</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>资源分散难共享，整体成本居高</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>客户管理分散，价值挖掘不充分</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 100%;height: 100%;position: absolute;left: 0px;top: 0px;"
            :style="[{ backgroundImage: 'url(' + require('@/assets/home/hy8.png') + ')' }, { opacity: hjindex == 8 ? 1 : 0 }]">
            <transition name="oxyshow">
              <div style="padding: 50px;" v-if="hjindex == 8">
                <div style="font-size: 28px;">安全云平台赋能，打通协作提服务</div>
                <div style="padding:60px 0px;">
                  <div><label style="margin-right: 15px;">★</label>教学数据分散难整合，决策缺乏依据</div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>公共服务响应慢，群众满意度低 </div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>审批流程繁复，一网通办落地难 </div>
                  <div style="margin-top: 15px;"><label style="margin-right: 15px;">★</label>数据安全风险高，治理透明度不足</div>
                </div>
              </div>
            </transition>
          </div>
          <div style="display: flex;position: absolute;left: 50px;bottom: 60px;">
            <div @click="tob" class="lifors"
              style="width: 120px;height: 36px;line-height: 36px;text-align: center;border-radius: 20px;font-size: 14px;color: #fff;cursor: pointer;background: #1e66d1;">
              立即咨询
            </div>
            <div @click="toa" class="lifors"
              style="margin-left: 10px; width: 120px;height: 36px;line-height: 36px;text-align: center;border-radius: 20px;font-size: 14px;color: #fff;cursor: pointer;background: #728097;">
              如何解决
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div style="position: relative;margin-top: 150px;">
      <div style="font-size: 40px;font-weight: normal;text-align: center;">合作案例</div>
      <div style="padding-top: 40px;">
        <div class="mendiv">
          <div @mouseenter="setapps(i)" @click="setapps(i)" class="pointer hprimary" v-for="(x, i) in menus"
            :class="{ 'mtitle': i == mindex }">
            {{
              x.name
            }}</div>
        </div>
      </div>
    </div>
    <div style="background: #f5f7fa;padding-bottom: 20px;">
      <div class="hezuoanlie"
        style="display: flex;flex-wrap: wrap;width: 1200px;justify-content: center;margin: 0px auto;justify-content:space-between;padding:35px 0px;">
        <div v-show="x.img" style="margin: 10px 0px;padding: 0px 0px;background: #fff;width: 23%;"
          v-for="(x, i) in apps" :key="i">
          <img style="width: 100%;" :src="action + x.img" :alt="x.name">
        </div>
      </div>
    </div>
    <div v-if="videoShow" @click="videoShow = false"
      style="position: fixed;width: 100%;height: 100%;top: 0px;left: 0px;background: rgb(0 0 0 / 50%);z-index: 999999999;">
      <div @click.stop="videoShow = true"
        style="position: absolute;width: 1000px;top: 50%;left: 50%;transform: translate(-50%, -50%);cursor: pointer;">
        <video class="videosss" preload="auto"
          style="border-radius: 10px;background: #333;padding: 20px;width: 1000px;max-height: 80vh;" controls autoplay
          :poster="mp4obj.img">
          <source :src="mp4obj.video" type="video/mp4">
        </video>
        <img @click="videoShow = false" alt="关闭" style="right: -0px;position: absolute;top: -0px;width: 35px;height: 35px;"
          src="../../assets/home/delete.png"></img>
        <!-- <div style="right: 0px;position: absolute;top: 10px;width: 50px;height: 50px;font-size: 16px;color: #fff;">关闭</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import 'swiper/swiper-bundle.css'
// import { Swiper } from "swiper"
// import { Autoplay, Pagination, Navigation } from "swiper/modules"
import { getJsonTree } from '@/utils/index'
import { detailPath } from '@/utils/route-params'
var isMouseDown = false;
var ul = null;
var isclick = true
export default {
  data() {
    return {
      ispc: true,
      show: true,
      showb: false,
      showc: false,
      index: 0,
      tindex: 1,
      windex: 0,
      hjindex: 1,
      action: '',
      mindex: 0,
      menus: [],
      apps: [],
      imgindex: 0,
      videoShow: false,
      mp4obj: {},
      videobindex: 1,
      left: 0,
      mp4: [[
        { title: '企业AI智能体中台', img: require("../../assets/mp4/视频封面24.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/0c0f49065145403720998709341/v.f100800.mp4' },
        { title: '腾讯智能体开发平台', img: require("../../assets/mp4/视频封面22.png"), video: 'https://1312339042.vod-qcloud.com/46ecf4edvodtranssh1312339042/267361275145403707757025974/v.f100800.mp4' },
        { title: '腾讯小龙虾WorkBuddy', img: require("../../assets/mp4/视频封面27.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/097740195145403728111632276/v.f100800.mp4' },
        { title: 'WorkBuddy企业版', img: require("../../assets/mp4/视频封面28.png"), video: 'https://1312339042.vod-qcloud.com/46ecf4edvodtranssh1312339042/ab5ae1465001834806048186595/v.f100800.mp4' },
        { title: '企业用AI，为什么两极分化', img: require("../../assets/mp4/视频封面29.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/fbd0afa45001834808446891082/v.f100800.mp4' },
        { title: '企业级AI应用落地案例', img: require("../../assets/mp4/视频封面23.png"), video: 'https://1312339042.vod-qcloud.com/46ecf4edvodtranssh1312339042/0631fc545145403712979891758/v.f100800.mp4' },
      ], [
        { title: 'AI知识库2.0', img: require("../../assets/mp4/视频封面26.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/c7ec27615145403726433228359/v.f100800.mp4' },
        { title: 'AI智能客服', img: require("../../assets/mp4/视频封面19.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/3525dae35145403695701168913/v.f100800.mp4' },
        { title: 'AI知识库', img: require("../../assets/mp4/视频封面3.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/6bc392895145403694067964236/v.f100800.mp4' },
        { title: 'AI+企业微信会话记录', img: require("../../assets/mp4/视频封面20.png"), video: 'https://1312339042.vod-qcloud.com/46ecf4edvodtranssh1312339042/683eb6b65145403699875378706/v.f100800.mp4' },
        { title: '智能运维应用搭建案例', img: require("../../assets/mp4/视频封面25.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/a123623e5145403723066712836/v.f100800.mp4' },
        { title: '快速搭建AI智能应用', img: require("../../assets/mp4/视频封面21.png"), video: 'https://1312339042.vod-qcloud.com/46ecf4edvodtranssh1312339042/36cf95315145403699871499260/v.f100800.mp4' },
      ], [
        { title: 'AI智慧党建', img: require("../../assets/mp4/视频封面4.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/eb18ef125145403694062998657/v.f100800.mp4' },
        { title: 'AI信息安全', img: require("../../assets/mp4/视频封面5.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/fc1d30415145403694069528014/v.f100800.mp4' },
        { title: '公司服务介绍', img: require("../../assets/mp4/视频封面1.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/184c4f5a5145403694073440442/v.f100800.mp4' },
        { title: '企业信息化选型之路', img: require("../../assets/mp4/视频封面2.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/f4d45b415145403694385120952/v.f100800.mp4' },
        { title: '私域助手', img: require("../../assets/mp4/视频封面6.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/3812920c5145403694063997309/v.f100800.mp4' },
        { title: '智慧校园方案', img: require("../../assets/mp4/视频封面7.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/22ffe3205145403694063083527/v.f100800.mp4' },
      ], [
        { title: '场馆预约系统', img: require("../../assets/mp4/视频封面8.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/b940588d5145403694075740987/v.f100800.mp4' },
        { title: '统一支付对账系统', img: require("../../assets/mp4/视频封面9.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/4b4a93fb5145403694291915110/v.f100800.mp4' },
        { title: '食堂点餐系统', img: require("../../assets/mp4/视频封面10.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/7f449ccf5145403694295923676/v.f100800.mp4' },
        { title: '校友捐赠系统', img: require("../../assets/mp4/视频封面11.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/b7c143c85145403694296097504/v.f100800.mp4' },
        { title: '故障报修系统', img: require("../../assets/mp4/视频封面12.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/cc87216b5145403694296963028/v.f100800.mp4' },
        { title: '失物招领系统', img: require("../../assets/mp4/视频封面13.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/9dff9e655145403694078663270/v.f100800.mp4' },
      ], [
        { title: '自助迎新系统', img: require("../../assets/mp4/视频封面14.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/c8b5b1975145403694072302830/v.f100800.mp4' },
        { title: '疫情防控系统', img: require("../../assets/mp4/视频封面15.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/e0cd33295145403694293749027/v.f100800.mp4' },
        { title: '智慧党建系统', img: require("../../assets/mp4/视频封面18.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/9011a9de5145403694078071234/v.f100800.mp4' },
        { title: '访客预约系统', img: require("../../assets/mp4/视频封面16.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/b331f15f5145403694302472339/v.f100800.mp4' },
        { title: '用车管理系统', img: require("../../assets/mp4/视频封面17.png"), video: 'https://1312339042.vod-qcloud.com/e7f97e26vodtranscq1312339042/ae3fd5b75145403694082041550/v.f100800.mp4' },
      ]],
      // cards: [
      //   { img: require("../../assets/home/fa-1@3x.png"), title: '教育', text: '构建智慧校园平台，整合教学管理全场景，驱动数字化升级，显著提升教学与管理效能' },
      //   { img: require("../../assets/home/fa-2@3x.png"), title: '制造', text: '打造敏捷工业数字平台，实现生产全流程智能管控与协同，降本增效，加速智造转型' },
      //   { img: require("../../assets/home/fa-3@3x.png"), title: '设计院', text: '统一平台整合项目流程与知识资产，支持协同设计与审签，保障安全合规，缩短周期' },
      //   { img: require("../../assets/home/fa-4@3x.png"), title: '零售', text: '全链路数字化整合人货场，数据智能驱动精准营销与高效运营，优化体验与供应链' },
      //   { img: require("../../assets/home/fa-5@3x.png"), title: '金融', text: '覆盖客户全周期服务与智能风控，提升业务效率，优化体验，构建安全运营体系' },
      //   { img: require("../../assets/home/fa-6@3x.png"), title: '医药', text: '提供研发生产全场景方案，强化GMP合规与质量追溯，提升运营效率与管控水平' },
      //   { img: require("../../assets/home/fa-7@3x.png"), title: '集团', text: '打造数字化中枢平台，强化多业态协同与移动审批，优化资源配置，降低管理成本' },
      //   { img: require("../../assets/home/fa-8@3x.png"), title: '政务', text: '搭建安全政务云平台，打通跨部门协作与一网通办，提升治理响应与公众满意度' },
      // ]
    }
  },
  created() {
    this.action = window['pathConfig'][process.env.NODE_ENV].ImgURL
    this.$http('/Plan/GetTypeData', { isall: 3 }).then(x => {
      if (x.data.length > 0) {
        var data = getJsonTree(x.data, '', 'pid')
        this.menus = data
        this.setapps(0)
        this.load()
      }
    })
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.ispc = false
    } else {
      this.ispc = true
    }
  },
  activated() {
  },
  mounted() {
    ul = document.getElementById('scrollcontainer');
    ul.addEventListener('mousedown', (e) => {
      isMouseDown = true;
    })
    ul.addEventListener('mousemove', (e) => {
      if (isMouseDown) {
        console.log(1)
        isclick = false
        ul.scrollBy(-e.movementX, 0);
      }
    })
    ul.addEventListener('mouseup', (e) => {
      isMouseDown = false;
      setTimeout(function () {
        isclick = true
      }, 1);

    })
    ul.addEventListener('mouseleave', (e) => {
      isMouseDown = false;
      setTimeout(function () {
        isclick = true
      }, 1);
      autoScroll()
    })
    var w = window.innerWidth
    if (w < 1540) {
      ul.style.zoom = 0.8
    }
    else if (w < 1600) {
      ul.style.zoom = 0.9
    } else {
      if (w < 1800) {
        ul.style.zoom = 0.9
      }
    }
    const box = ul;
    // 滚动速度，数值越大滚动越快（推荐0.5 ~ 2之间）
    const speed = 0.8;
    // 滚动方向 1=向右，-1=向左
    let direction = 1;
    // 最大可滚动距离 = 内容宽度 - 容器可视宽度
    const maxScroll = box.scrollWidth - box.clientWidth;

    let animateId;
    function autoScroll() {
      // 根据方向修改滚动值
      box.scrollLeft += speed * direction;

      // 触达最右侧，切换向左回滚
      if (box.scrollLeft >= maxScroll) {
        direction = -1;
      }
      // 回到最左侧，切换向右滚动
      if (box.scrollLeft <= 0) {
        direction = 1;
      }
      animateId = requestAnimationFrame(autoScroll);
    }
    box.addEventListener('mouseenter', () => cancelAnimationFrame(animateId))
    // 启动滚动
    autoScroll();
  },
  methods: {
    to(name) {
      this.$router.push({ name: name })
    },
    // toa() {
    //   this.$router.push({ name: 'solution', query: { index: this.hjindex - 1 } })
    // },
    tob() {
      if (this.$isxj)
        window.open('https://work.weixin.qq.com/kfid/kfc54a4ebac7513c548')
      else
        window.open('https://work.weixin.qq.com/kfid/kfc31843ffccca81b46')
    },
    tod(title) {
      this.$router.push(detailPath('/product', title))
    },
    toc(title) {
      this.$router.push(detailPath('/app', title))
    },
    toe() {
      if (this.tindex == 1)
        this.$router.push({ name: 'product' })
      else if (this.tindex == 2)
        this.$router.push({ name: 'app' })
    },
    tof(title) {
      this.$router.push(detailPath('/AIMenu', title))
    },
    tog(i) {
      if (isclick) {
        this.$router.push(detailPath('/wbIndustry', i))
      }
    },
    toh(i) {
      if (isclick) {
        this.$router.push(detailPath('/solution', i))
      }
    },
    toz() {
      this.$router.push(detailPath('/WorkBuddy', '6'))
    },
    videoShowFun(x) {
      this.mp4obj = x
      this.videoShow = true
    },
    setapps(i) {
      this.mindex = i
      this.apps = this.menus[i].children
    },
    load() {
      // var swiper = new Swiper(".banner-swiper", {
      //   modules: [Autoplay, Pagination, Navigation],
      //   // 循环模式
      //   loop: true,

      //   // 前进后退按钮
      //   navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev",
      //   },

      //   // 自动播放
      //   autoplay: {
      //     delay: 1000000,
      //     disableOnInteraction: false,
      //   },
      // })

      // var _this = this
      // swiper.on("slideChange", () => {
      //   const realIndex = swiper.realIndex
      //   _this.imgindex = realIndex
      // })
    }
  }
}
</script>
<style>
#home .mendiv {
  display: flex;
  justify-content: center;
}

#home .mtitle {
  font-size: 16px;
  color: #1e66d1 !important;
  font-weight: bold;
  border-bottom: 2px solid #1e66d1;
}

#home .mendiv div {
  padding: 0px 15px 18px 15px;
  margin: 0px 5px;
  font-size: 16px;
  color: #666;
}

#home .banner-swiper {
  position: relative;
  overflow: hidden;
}

.banner-swiper .swiper-button-prev,
.banner-swiper .swiper-button-next {
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  color: #333;

  width: 50px;
  height: 50px;
}

.banner-swiper .swiper-button-prev:after,
.banner-swiper .swiper-button-next:after {
  font-size: 20px;
  font-weight: bold;
}

.whyus-swiper {
  position: relative;
  overflow: hidden;
}

.whyus-item {
  transition: all 0.3s ease-in-out;
  text-align: center;
  padding: 2.5rem 1rem;
  background-color: #f2f3f5;
  flex: 1;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.whyus-item:after {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  content: "";
  display: block;
  height: 4px;
  width: 100%;
  opacity: 0;
  background-color: var(--color-primary);
  transition: opacity 0.3s ease-in-out;
}

.whyus-item.active {
  background-color: #f8f9fa;
}

.whyus-item.active:after {
  opacity: 1;
}

.whyus-item:hover {
  background-color: #f8f9fa;
}

.whyus-item:hover:after {
  opacity: 1;
}

.whyus-item h3 {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.whyus-item p {
  color: #4b5563;
  line-height: 1.75;
  white-space: pre-line;
}

.slogan-text-font {
  font-size: 36px;
  display: flex;
  align-items: center;
}

.slogan-detail-card-title {
  font-size: 20px;
  display: relative;
}

.slogan-card {
  color: var(--color-content1);
  display: flex;
  height: 250px;
  width: 200px;
  flex-direction: column;
  align-items: center;
  border-radius: 1rem;
  background-color: rgb(255 255 255 / 0.8);
  padding-top: 2rem;
  padding-bottom: 2rem;
  font-size: 0.875rem;
  line-height: 1.75rem;
}

::v-deep #content p {
  text-indent: 2em;
  line-height: 35px;
  font-size: 16px;
}

::v-deep #content p:nth-child(2) {
  margin-top: 35px;
}

::v-deep #content p:nth-child(3) {
  margin-top: 35px;
}

.ai-yycj .div {
  width: 300px;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  text-align: center;
  border-radius: 15px 15px 0px 0px;
  cursor: pointer;
}

.ai-yycj .isdiv {
  font-weight: bold;
  background: #1e66d1;
  color: #fff;
}

.ai-gnzs div {
  width: 160px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  color: #999999;
  background: #ebebeb;
  margin-bottom: 10px;
  border-radius: 10px;
  cursor: pointer;
}

.ai-gnzs .isdiv {
  background: #fff;
  color: #333;
}

#homemenu {
  font-size: 18px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

#homemenu div {
  padding: 0px 35px;
  padding-bottom: 4px;
}

#homemenu .ttitle {
  font-size: 40px;
  padding-bottom: 0px;
  position: relative;
  cursor: pointer;
}

#homemenu .ttitle:after {
  content: '';
  position: absolute;
  left: 0px;
  right: 0px;
  margin: 0px auto;
  bottom: -30px;
  height: 4px;
  width: 100px;
  background-color: #1e66d1;
}

#homeapp .happ {
  border: 1px solid transparent;
  border-radius: 10px;
  /* width: 237px; */
  overflow-x: hidden;
  cursor: pointer;
  padding: 12px 8px !important;
}

#homeapp .happ:hover {
  background: #f9fbff;
  border: 1px solid #96bcf5;
}

#homejjfz .hjmenu {
  background: linear-gradient(90deg, #003f9d, #1e66d1);
  border: 0px solid rgb(47 131 255) !important;
}

#homeapp .WorkBuddyapp {
  width: 250px;
  height: 230px;
  margin-bottom: 5px;
}

.homeappbutton {
  margin: 0px auto;
  width: 200px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border: 1px solid #aacbfd;
  border-radius: 30px;
  font-size: 14px;
  background: #f8f8f8;
  margin-top: 10px;
  color: #666;
}

.videobutton {
  display: flex;
  justify-content: center;
  align-items: center;
}

.videobutton div {
  height: 6px;
  width: 60px;
  cursor: pointer;
}

.videobutton div:hover {
  background: #1e66d183 !important;
}

#scrollcontainer img {
  /* 禁止图片拖拽 */
  pointer-events: none;
  -webkit-user-drag: none;
  /* user-drag: none; */
  /* 禁止鼠标选中图片文字 */
  user-select: none;
}

@keyframes oxyshow {
  0% {
    opacity: 0;
    transform: translateX(50px);
  }

  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

.oxyshow-enter-active {
  animation: oxyshow 1s ease-in-out;
}

/* .oxyshow-leave-active {
  animation: oxyshow 1s ease-in-out reverse;
} */

@keyframes qweqwe {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.qweqwe-enter-active {
  animation: qweqwe 0.5s ease-in-out;
}

/* .qweqwe-leave-active {
  animation: qweqwe 0s ease-in-out reverse;
} */

footer {
  --color-primary: #1e66d1;
}

.workbudoyhangye {
  width: 380px;
  transition: transform 0.1s ease;
}

.workbudoyhangye:hover {
  transform: scale(1.01);
}

.workbudoyhangyeb {
  width: 385px;
  height: 550px;
  transition: transform 0.1s ease;
}

.workbudoyhangyeb:hover {
  transform: scale(1.01);
}




.scroll-container::-webkit-scrollbar {
  /* WebKit */
  display: none;
}
</style>
